import { isDebugWebrtcLoggingEnabled } from '@playcastdotio/PeerCore';

/**
 * DEBUG BUILD ONLY — forward a rig log line to the on-disk NDJSON sink.
 *
 * The host window runs with contextIsolation on from a remote origin, so the page has no
 * filesystem access; the only path to disk is the host-electron main process, exposed as
 * `window.playcast.appendDebugLog`. When running inside host-electron in a debug build
 * (or under `?debug`), every rig line the debug gate produces is ALSO appended to
 * `C:\ProgramData\Playcast\logs\webrtc-debug.ndjson`, so a field session can be replayed
 * from disk without DevTools. Outside host-electron (plain browser, tests) this is a no-op,
 * and production builds constant-fold the gate away entirely.
 *
 * Fire-and-forget: a failed IPC never surfaces to the caller, and the main process
 * serializes appends so concurrent 1 Hz polls cannot interleave JSON lines.
 */
export function sinkWebrtcDebugLine(line: string): void {
  if (!isDebugWebrtcLoggingEnabled()) return;
  try {
    const bridge = (window as unknown as { playcast?: { appendDebugLog?: (l: string) => Promise<void> } })
      .playcast;
    if (typeof bridge?.appendDebugLog !== 'function') return;
    void bridge.appendDebugLog(line).catch(() => undefined);
  } catch {
    // No window / no bridge — browser-hosted page; console-only logging applies.
  }
}